module.exports = __webpack_public_path__ + "static/Ciutadella-Regular-d343acf7cabaf2e89552eafb35ce578f.woff";